import { render } from "./BetDetail.vue?vue&type=template&id=26adc8f0&scoped=true"
import script from "./BetDetail.vue?vue&type=script&lang=js"
export * from "./BetDetail.vue?vue&type=script&lang=js"

import "./BetDetail.vue?vue&type=style&index=0&id=26adc8f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26adc8f0"]])

export default __exports__